(function ($) {
    $(document).ready(function ($) {
        url = window.alertsUrl || "";
        if (url && url.length) {
            $.getJSON(url, { _: new Date().getTime() }, alertsCallback);
        }
    });

    function hashCode(str) {
        var hash = 0;
        if (str.length == 0) return hash;
        for (i = 0; i < str.length; i++) {
            char = str.charCodeAt(i);
            hash = (hash << 5) - hash + char;
            hash = hash & hash; // Convert to 32bit integer
        }
        return hash;
    }

    function alertsCallback(data) {
        var alertHash = hashCode(JSON.stringify(data));
        var alerts_panel = $("#panel__alerts");
        var alerts_template = $("#alerts-template");
        var alertCookie = Cookies.get("alerthash");

        if (alertCookie == alertHash) {
            $("#panel__alerts").css("display", "none");
            $("#toggle__alert").css("display", "flex");
            $("body").addClass("alert-closed");
        }

        var alerts = [];
        if (data[1] && data[1].length) {
            alerts = alerts.concat(data[1]);
        }
        if (
            alertsBlogId > 1 &&
            data[alertsBlogId] &&
            data[alertsBlogId].length
        ) {
            alerts = alerts.concat(data[alertsBlogId]);
        }
        var alertString;

        for (var i = 0; i < alerts.length; i++) {
            var alertHtml = alerts_template.html();
            alertString = alerts[i].alert_select;

            var currentTimestamp = Math.floor(Date.now() / 1000);
            var startTimestamp = Math.floor(
                new Date(alerts[i].alert_start_time).getTime() / 1000
            );
            var endTimestamp = Math.floor(
                new Date(alerts[i].alert_end_time).getTime() / 1000
            );

            if (
                currentTimestamp < startTimestamp ||
                currentTimestamp > endTimestamp
            ) {
                continue;
            }

            //we expect the alert data to be in the form: severity - label
            if (alertString != "other") {
                alertString = alertString.split("-");

                if (typeof alertString[1] !== "undefined") {
                    //check to see if we have a proper alert
                    alertHtml = alertHtml.replace(
                        /{{severity}}/,
                        alertString[0]
                    );
                    alertHtml = alertHtml.replace(
                        /{{category}}/,
                        alertString[1]
                    );
                    alertHtml = alertHtml.replace(
                        /{{description}}/,
                        alerts[i].alert_description
                    );
                }
            } else {
                alertHtml = alertHtml.replace(
                    /{{severity}}/,
                    alerts[i].alert_severity
                );
                alertHtml = alertHtml.replace(
                    /{{category}}/,
                    alerts[i].alert_category
                );
                alertHtml = alertHtml.replace(
                    /{{description}}/,
                    alerts[i].alert_description
                );
            }

            var link = "";
            if (alerts[i].alert_more == "external") {
                link = alerts[i].alert_more_url;
            } else if (alerts[i].alert_more == "internal") {
                link = alerts[i].alert_more_page;
            }
            alertHtml = alertHtml.replace(/{{link}}/, link);

            var alertElem = jQuery.parseHTML(alertHtml);
            if (alerts[i].alert_more == "none") {
                $(alertElem).find(".alert__permalink").remove();
            }
            alerts_panel.append(alertElem);
        }

        if (alerts_panel.find(".alert").length > 0) {
            $("body").addClass("has-alerts");

            // Remove hidden class
            alerts_panel.removeClass("js-hide");

            // Initialize carousel
            alerts_panel.owlCarousel({
                loop: true,
                items: 1,
                animateOut: "fadeOut",
                animateIn: "fadeIn",
                responsiveClass: true,
                autoHeight: true,
                autoplay: true,
            });
        }

        //add padding for dots and force refresh to give proper height
        if (alerts_panel.find(".alert").length > 1) {
            $(".owl-stage-outer").addClass("owl-stage-outer--multi-alert");
        }
        alerts_panel.owlCarousel().trigger("refresh.owl.carousel");

        //Copy correct alert html to button
        var category;
        var severity;

        //bail out if there are no active alerts to render
        if (alerts.length > 0) {
            if (alerts[0].alert_category === "") {
                category = alertString[1];
            } else {
                category = alerts[0].alert_category;
            }

            if (alerts[0].alert_category === "") {
                severity = alertString[0];
            } else {
                severity = alerts[0].alert_severity;
            }

            if (alerts.length < 2) {
                $("#toggle__alert").html(
                    '<div class="alert alert--' +
                        severity +
                        '"><span class="alert__category">' +
                        category +
                        "</span></div>"
                );
                $("#header-container header").prepend(
                    '<div class="alert-border alert--' + severity + '"></div>'
                );
            }

            if (alerts.length > 1) {
                $("#toggle__alert").html(
                    '<div class="alert alert--normal"><i class="material-icons">notifications</i>Alerts</span></div>'
                );
                $("#header-container header").prepend(
                    '<div class="alert-border alert--normal"></div>'
                );
            }
        }

        $(".alert__close").click(function (e) {
            e.preventDefault();
            $("#panel__alerts").css("display", "none");
            $("#toggle__alert").css("display", "flex");
            $("body").addClass("alert-closed");
            Cookies.set("alerthash", alertHash);
            $("body").removeClass("alert-open");
        });

        $("#toggle__alert").click(function (e) {
            e.preventDefault();
            $("#panel__alerts").css("display", "block");
            $("#toggle__alert").css("display", "none");
            $("body").removeClass("alert-closed");
            $("body").addClass("alert-open");
        });
    }
})(jQuery);
